import { render } from "./Assets.vue?vue&type=template&id=c035357e&scoped=true"
import script from "./Assets.vue?vue&type=script&lang=js"
export * from "./Assets.vue?vue&type=script&lang=js"

import "./Assets.vue?vue&type=style&index=0&id=c035357e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c035357e"

export default script